import { render } from "./BasicAnalyseView.vue?vue&type=template&id=736a56f8&scoped=true"
import script from "./BasicAnalyseView.vue?vue&type=script&lang=js"
export * from "./BasicAnalyseView.vue?vue&type=script&lang=js"

import "./assets/basic_index.css?vue&type=style&index=0&id=736a56f8&scoped=true&lang=css"

import exportComponent from "/Users/baojian/Documents/anyway/anyway-wx/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736a56f8"]])

export default __exports__